// eslint-disable-next-line import/prefer-default-export
export const formatHoursAndMinutes = (
  hour: string | undefined,
): string | "" => {
  if (!hour) return "";
  const result = hour.match(/(?:(?:^|:)[^:]*){2}/);
  return result?.length ? result[0] : "";
};
